export default {"src":"/_next/static/media/document-paper.2c91f650.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};